export const materialValidationRules = (values) => {
  const errors = {};

  if (!values.name || values.name.trim() === "") errors.name = "Name is required";
  else if (values.name && values.name.length < 3) errors.name = "Name must be at least 3 characters";
  else if (values.name && values.name.length > 50) errors.name = "Name must be at most 50 characters";
  if (!values.unitOfMeasure) errors.unitOfMeasure = "Please select a unit";
  if (Number(values.defaultPrice) < 0) errors.defaultPrice = "Price must be greater than 0";

  return errors;
};
